import React from 'react';
import UsersPage from './UsersPage';

const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 768;
};

const UsersPageWrapper: React.FC = () => {
  const [mobile, setMobile] = React.useState(isMobile());

  React.useEffect(() => {
    const handleResize = () => {
      setMobile(isMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // For now, use the same page for both mobile and desktop
  // Can create UsersPageMobile later if needed
  return <UsersPage />;
};

export default UsersPageWrapper;

